import React from "react"

import styles from './index.module.scss';

export default function RcmpContainer(props) {
    const { children, className, ...oRest } = props
    const classes = `${styles.container} ${className ? className : ""}`
    return (
        <div className={classes} {...oRest}>
            {children}
        </div>
    );
}